import { Button, Form, Input, Typography, message } from "antd";
import { useState } from "react";
import { loginUser } from "../../../api/auth.module";
import { useDispatch } from "react-redux";
import { setUser } from "../../../redux/slices/authSlice";

const { Paragraph, Text } = Typography;

function LoginForm({ setLoginPage, setOpenAuth }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const handleSubmit = async (v) => {
    setLoading(true);
    try {
      const dt = await loginUser(v);
      if (dt.token) {
        message.success("Login successful");
        dispatch(setUser(dt.data));
        setOpenAuth(false);
      } else {
        message.error(dt.message);
      }
    } catch (error) {
      console.log(error);
      message.error(error.response.data.message);
      setLoading(false);
    }
  };
  return (
    <div>
      <Paragraph
        style={{
          textAlign: "center",
          padding: "1rem 0",
          background: "#0c6f8d",
          color: "#f1f1f1",
        }}
      >
        Sign In into my Services
      </Paragraph>
      <Form name="login-form" onFinish={handleSubmit}>
        <Form.Item
          name="email"
          rules={[{ required: true, message: "Please provide email address!" }]}
        >
          <Input placeholder="Email address" />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: "Please provide password!" }]}
        >
          <Input.Password placeholder="Password" />
        </Form.Item>
        <Paragraph style={{ textAlign: "right" }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Login
          </Button>
        </Paragraph>
        <Paragraph style={{ padding: "2rem 0", textAlign: "center" }}>
          Don't have an account?{" "}
          <Text
            style={{ cursor: "pointer", color: "#89d" }}
            onClick={() => setLoginPage(false)}
          >
            SignUp
          </Text>
        </Paragraph>
      </Form>
    </div>
  );
}

export default LoginForm;
